import { StepLabel as MuiStepLabel, StepLabelProps } from '@mui/material'

export type BaseStepLabelProps = StepLabelProps

export function BaseStepLabel(props: BaseStepLabelProps) {
    return <MuiStepLabel {...props} />
}
